import { Divider, Form, Input, message, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { userLogin } from "../../../api/userAuth";
import Clients from "../../../assets/agentLogin.svg";
import Background from "../../../assets/bg.svg";
import Error from "../../../assets/error.svg";
import Check from "../../../assets/tick.svg";
import LoginLayout from "../../../components/LoginLayout";
import Button from "../../../components/button";
import MemberModal from "../../../components/memberModal";
import Logo from "../../../assets/logo.svg";
import PhoneNumberInput from "../../../components/phoneNumber";
import InputField from "../../../components/inputField";
import { handleAuthRedirect } from "../../../constants/utils";

const UserLogin = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [contactMethod, setContactMethod] = useState("phone");
  const navigate = useNavigate();

  const handleContactChange = (e) => {
    setContactMethod(e.target.value);
  };

  const onFinish = async (values) => {
    setLoader(true);
    const payload = {
      dotNumber: values.dotNumber,
      ...(contactMethod === "phone"
        ? { phoneNumber: values.phoneNumber }
        : { email: values.email }),
    };
    try {
      const res = await userLogin(payload);
      if (res) {
        setLoader(true);
        navigate("/user/verification");
        localStorage.setItem("otpToken", res?.otp_token);
        localStorage.setItem("phoneNumber", res?.data?.phoneNumber);
        localStorage.setItem("Login", "User");
      } else {
        showErrorModal();
      }
    } catch ({ response }) {
      message.error(response?.data?.message || "Bad request");
      showErrorModal();
    } finally {
      setLoader(false);
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const showErrorModal = () => {
    setIsErrorModal(true);
  };
  const YesClickHandler = () => {
    navigate("/main/user/otp");
    setIsModalOpen(false);
  };
  const NoClickHandler = () => {
    setIsErrorModal(false);
  };
  const hideModal = () => {
    setIsModalOpen(false);
    setIsErrorModal(false);
  };
  const Back = () => {
    navigate("/");
  };
  useEffect(() => {
    const AdminLogin = localStorage.getItem("Login");
    const Token = localStorage.getItem("accessToken");
    if (AdminLogin && Token) {
      handleAuthRedirect(AdminLogin, navigate);
    }
  }, [navigate]);
  return (
    <div>
      <LoginLayout image={Clients} bg={Background}>
        <div className="relative">
          <div className="absolute w-5 h-5 bg-blue-500 rounded-full left-10 top-7" />
          <div className="absolute top-0 right-0 w-24 h-24 bg-blue-500 rounded-bl-full" />
        </div>

        <div className="min-h-screen flex items-center justify-center">
          <div className="mx-4 sm:mx-6 lg:mx-20 xl:mx-40 w-full max-w-md">
            <div className="flex justify-center">
              <Link to="https://insurancehive.com/">
                <img src={Logo} alt="logo" className="cursor-pointer" />
              </Link>
            </div>
            <div className="space-y-5">
              <p className="text-2xl sm:text-3xl lg:text-4xl text-center font-bold mt-5">
                Login to Policy Portal
              </p>
              <Radio.Group
                defaultValue="phone"
                onChange={handleContactChange}
                className="flex justify-center items-center"
              >
                <Radio.Button
                  value="phone"
                  className={`h-11 px-6 flex justify-center items-center rounded-lg transition-all duration-300 w-full ${
                    contactMethod === "phone"
                      ? "bg-indigo-600 text-white font-bold"
                      : "bg-gray-200 text-gray-800 hover:bg-gray-300 font-bold"
                  }`}
                >
                  Phone Number
                </Radio.Button>
                <Radio.Button
                  value="email"
                  className={`h-11 px-6 flex justify-center items-center rounded-lg transition-all duration-300 w-full ${
                    contactMethod === "email"
                      ? "bg-indigo-600 text-white font-bold"
                      : "bg-gray-200 text-gray-800 hover:bg-gray-300 font-bold"
                  }`}
                >
                  Email
                </Radio.Button>
              </Radio.Group>
              <div>
                <Form
                  form={form}
                  onFinish={onFinish}
                  name="signin"
                  layout="vertical"
                >
                  <Form.Item
                    name="dotNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please input your DOT Number",
                      },
                    ]}
                    label={
                      <span className="text-xl font-bold">DOT Number</span>
                    }
                  >
                    <InputField
                      name={"dotNumber"}
                      placeholder={"Write DOT Number"}
                      type={"text"}
                      inputType={"onlyNumbers"}
                    />
                  </Form.Item>
                  <Form.Item
                    name={contactMethod === "phone" ? "phoneNumber" : "email"}
                    rules={[
                      {
                        required: true,
                        message: `Please Enter Your ${
                          contactMethod === "phone" ? "Phone Number" : "Email"
                        }`,
                      },
                      {
                        type: contactMethod === "email" && "email",
                        message: "Please enter valid email",
                      },
                    ]}
                    label={
                      <span className="text-xl font-bold">
                        {contactMethod === "phone"
                          ? "Enter Phone Number"
                          : "Enter Email"}
                      </span>
                    }
                  >
                    {contactMethod === "phone" ? (
                      <PhoneNumberInput name={"phoneNumber"} />
                    ) : (
                      <InputField
                        name={"email"}
                        placeholder={"Enter your email"}
                        type={"text"}
                        inputType={"email"}
                      />
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Button
                      title={"Login"}
                      type={"primary"}
                      htmlType="submit"
                      loading={loader}
                    />
                  </Form.Item>
                  <div className="px-6">
                    <Divider className="bg-[#C7D1D9] border" />
                  </div>
                  <Form.Item className="hover:cursor-pointer">
                    <Button title={"Back"} type={"secondary"} onClick={Back} />
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute bottom-7 w-5 h-5 bg-blue-500 rounded-full left-10" />
          <div className="absolute right-0 bottom-0 w-24 h-24 bg-blue-500 rounded-tl-full" />
        </div>
      </LoginLayout>
      {isModalOpen && (
        <MemberModal
          image={Check}
          title="Verification Code Verfied"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
      {isErrorModal && (
        <MemberModal
          image={Error}
          title="Unable to Login"
          onCancel={hideModal}
          onOk={NoClickHandler}
        />
      )}
    </div>
  );
};

export default UserLogin;
